import script from "./rewardList.vue?vue&type=script&setup=true&lang=js"
export * from "./rewardList.vue?vue&type=script&setup=true&lang=js"

import "./rewardList.vue?vue&type=style&index=0&id=05ebeb6b&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\rcpetresort.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05ebeb6b"]])

export default __exports__